export default "__VITE_ASSET__BhEyDVO1__"